/* eslint-disable @typescript-eslint/naming-convention */
import { ProductThumbnailType2 } from "@/components/commons/productThumbnailType2"
import { Box } from "@chakra-ui/react"
import { useMediaQuery } from "@uidotdev/usehooks"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { COLLARTYPEKEY, breadCrumbFirstLevel, breadCrumbProductsSecondLevel, mobileBreakpoint } from "../../common/commonConstants"
import { UtilityFamilyImg } from "../../components/images"
import { SubPage, SubPageContent } from "../../components/SubPage"
import { BannerType1 } from "../../components/commons/bannerType1"
import { BreadCrumb } from "../../components/commons/breadcrumb"
import { Heading2CapsSubText } from "../../components/commons/heading2CapsSubText"
import { Loading } from "../../components/commons/loader.main"
import { chakraTheme } from "../../theme/chakraTheme"
import { useAllCollarsQuery, type AllCollarsQuery, type Product4Menu } from "../../type-and-hooks"

type AssociativeArray = Record<string, Product4Menu[]>

export const EndlessCollars = (): JSX.Element => {
  const { loading, data } = useAllCollarsQuery({ variables: { collarTypeId: COLLARTYPEKEY.ENDLESS }, fetchPolicy: "cache-and-network" })
  const [allCollarsCategory, setAllCollarsCategory] = useState<AssociativeArray>({})
  const navigate = useNavigate()
  const handleClick = (item: Product4Menu | undefined | null): void => {
    if (item?.prod_link) {
      navigate(item.prod_link ?? "/", { state: { pid: item.pid, catName: "Utility Collar", prodCode: item.prod_code } })
    } else {
      console.error("Product is not available", item)
    }
  }

  const getSubCategoryData = (data: AllCollarsQuery): AssociativeArray => {
    const acc: AssociativeArray = {}
    data?.allCollars?.map(item => {
      const subCategory = item?.subcategory ?? "unknown"
      if (item) {
        acc[subCategory] = [...(acc[subCategory] ?? []), item]
      }
      return acc
    })

    return acc
  }

  useEffect(() => {
    if (data) {
      setAllCollarsCategory(getSubCategoryData(data))
    }
  }, [data])
  const isMobile = useMediaQuery(`(max-width: ${mobileBreakpoint}px)`)
  const columnCount = isMobile ? 2 : 3

  return (
    <SubPage>
      <BannerType1
        heading="Utility Collar"
        subText1="Utility Collars are externally mounted collars designed to collapse pipes comprised of plastic and aluminium layers."
        image={UtilityFamilyImg}
        imageStyles={{ width: "401px", height: "258px" }}
      />
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          ...breadCrumbProductsSecondLevel,
          thirdLevel: { title: "Utility Collar" }
        }}
      />
      <SubPageContent props={{ mt: ["40px", "40px", "40px", 0, 0, 0] }}>
        <Box overflow={"hidden"} mb={["30px", "30px", "30px", "137px", "137px", "137px"]}>
          {allCollarsCategory &&
            Object.entries(allCollarsCategory).map(([key, collars], index) => (
              <>
                <Heading2CapsSubText
                  headingTextStyles={{
                    textAlign: "left",
                    fontSize: ["24px", "24px", "24px", "24px"],
                    fontWeight: 500,
                    lineHeight: "24px",
                    fontFamily: "Work Sans",
                    pt: index === 0 ? "10px" : "40px",
                    pb: "14px"
                  }}
                  subTextStyles={{ color: "#939598" }}
                  headingText={key !== "unknown" ? key : ""}
                  subText={`${collars.length ?? 0} items`}
                />
                <Loading loading={loading} />
                <Box display="grid" gridTemplateColumns={[`repeat(${columnCount}, 1fr)`]} gap="8px">
                  {collars.map((item, index) => (
                    <React.Fragment key={`${index}_allCollars`}>
                      <ProductThumbnailType2
                        onClickCallBack={() => {
                          handleClick(item)
                        }}
                        prodCode={item?.prod_code}
                        prodPhoto={item?.prod_photo}
                        bg={chakraTheme.colors.lightGray}
                      />
                      <>{(index + 1) % columnCount === 0 && <Box my="16px" gridColumn={`span ${columnCount}`} height="1px" bg="primary"></Box>}</>
                    </React.Fragment>
                  ))}
                </Box>
              </>
            ))}
        </Box>
      </SubPageContent>
    </SubPage>
  )
}
